import { buttonBarCss, CeruleanButton, GrayButton } from 'components/Button'
import Row from 'components/Row'
import { actions } from 'data'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { connect, ConnectedProps } from 'react-redux'
import styled from 'styled-components'

import Container from '../Modal/Container'

type PropsType = WrappedComponentProps & ConnectedProps<typeof connector>

const ButtonBar = styled(Row)`
  padding-top: 0.5rem;
  ${buttonBarCss};
`

const TurnOff = ({ hideModal, intl }: PropsType) => (
  <Container
    sub={intl.formatMessage(messages.sub_title_disable_2fa)}
    title={intl.formatMessage(messages.title_disable_2fa)}
  >
    <ButtonBar>
      <GrayButton e2e='cancelButton' onClick={hideModal} type='button'>
        {intl.formatMessage(messages.button_cancel)}
      </GrayButton>

      <CeruleanButton e2e='turnoffButton' type='submit'>
        {intl.formatMessage(messages.button_turn_off)}
      </CeruleanButton>
    </ButtonBar>
  </Container>
)

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => {
    dispatch(actions.app.hideModal('DISABLE_TWO_FACTOR'))
  }
})

const connector = connect(null, mapDispatchToProps)

export default injectIntl(connector(TurnOff))
